const cwsBox = document.querySelectorAll(".layers__tab");
const cwsTabs = document.querySelectorAll(".layers__tabs a");

cwsTabs.forEach((link) => {
  const active = "active";
  const tabs = document.querySelectorAll(".layers__tab");

  link.addEventListener("click", (e) => {
    e.preventDefault();

    const id = link.getAttribute("href").replace("#", "");

    cwsTabs.forEach((link) => {
      link.classList.remove(active);
    });

    tabs.forEach((tab) => {
      tab.classList.remove(active);
    });

    link.classList.add(active);
    document.getElementById(id).classList.add(active);
  });
});

cwsBox.forEach((box) => {
  const cwsLayers = box.querySelectorAll(".layer h3");
  const cwsLinks = box.querySelectorAll(".layers__links a");

  cwsLayers.forEach((btn, index) => {
    if (btn.closest(".layer").classList.contains("active")) {
      const txt = btn.closest(".layer").querySelector(".layer__txt");

      txt.style.height = `${txt.scrollHeight}px`;
    }

    btn.addEventListener("click", () => {
      const parent = btn.closest(".layer");
      const txt = parent.querySelector(".layer__txt");
      const boxes = box.querySelectorAll(".layer");
      const active = "active";

      boxes.forEach((box) => {
        box.classList.remove(active);
        box.querySelector(".layer__txt").style.height = 0;
      });

      parent.classList.add(active);

      if (txt !== null) {
        txt.style.height = `${txt.scrollHeight}px`;
      }

      cwsLinks.forEach((link) => {
        link.classList.remove(active);
      });

      cwsLinks[index].classList.add(active);
    });
  });

  cwsLinks.forEach((link, index) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      cwsLayers[index].click();
    });
  });
});
